import React, { useState } from 'react';
import { ArrowTopRightOnSquareIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import DataModal from '../DataModal';

interface DataBoxProps {
  dataFileId: number | null;
  dataFileName?: string;
  className?: string;
}

const DataBox: React.FC<DataBoxProps> = ({ 
  dataFileId, 
  dataFileName = "Data File",
  className = "" 
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleOpenModal = () => {
    if (dataFileId) {
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <div className={`border border-secondary-200 rounded-lg p-3 bg-white ${className}`}>
        <div className="flex justify-between items-center">
          <h3 className="text-sm font-semibold text-secondary-900 flex items-center">
            <DocumentTextIcon className="w-4 h-4 text-primary-600 mr-2" />
            View Data Content
          </h3>
          <button
            onClick={handleOpenModal}
            disabled={!dataFileId}
            className={`text-secondary-600 hover:text-secondary-800 transition-colors p-1 rounded hover:bg-secondary-100 ${
              !dataFileId ? 'opacity-50 cursor-not-allowed' : ''
            }`}
            title="View data"
          >
            <ArrowTopRightOnSquareIcon className="w-5 h-5" />
          </button>
        </div>
        <p className="text-xs text-secondary-600">
          {dataFileId 
            ? `View data from ${dataFileName}`
            : 'Select a data file to view its contents'}
        </p>
      </div>

      {/* Data Modal */}
      <DataModal
        isOpen={showModal}
        onClose={handleCloseModal}
        dataFileId={dataFileId}
        dataFileName={dataFileName}
      />
    </>
  );
};

export default DataBox;
